(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pragmatic", [], factory);
	else if(typeof exports === 'object')
		exports["pragmatic"] = factory();
	else
		root["pragmatic"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 